import { GraphQLClient } from 'graphql-request'
import { getSdk } from '../generated/graphql'

const tfGraphqlClient = getSdk(
  new GraphQLClient(`${process.env.NEXT_PUBLIC_TF_API_URL}/api/v2/shop/graphql`)
)

export default tfGraphqlClient
